import styled from 'styled-components';
import { Colors } from 'axl-reactjs-ui';

export const Container = styled.div`
  padding: 30px 50px;
  text-align: left;
  border-radius: 5px;
`;
export const Title = styled.div`
  font-family: 'AvenirNext-Medium';
  font-size: 30px;
  font-weight: 500;
  color: #4a4a4a;
  margin: 0 0 20px;
`;
export const SubTitle = styled.div`
  font-family: 'AvenirNext-DemiBold';
  font-size: 14px;
  font-weight: 600;
  color: #96979a;
  margin-bottom: 15px;
`;
export const Text = styled.div`
  font-family: AvenirNext;
  font-size: 12px;
  line-height: 20px;
  color: #3b3b3b;
`;
export const Link = styled.a`
  font-family: AvenirNext;
  font-size: 12px;
  line-height: 20px;
  color: #3b3b3b;
  text-decoration: none;
`;
export const Action = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;
export const FileName = styled(Text)`
  margin: 0 0 0 10px;
`;
export const Actions = styled.div`
  text-align: right;
`;
export const GroupControl = styled.div`
  margin-bottom: 30px;
`;
export const GroupControlSelect = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const ListErrors = styled.ul`
  border: 1px solid ${Colors.dustyRed};
  padding: 20px 10px 20px 30px;
  border-radius: 5px;
`;
export const ErrorItem = styled.li`
  color: ${Colors.dustyRed};
  font-size: 12px;
`;

export default {
  actions: {
    minWidth: 150,
    margin: '0 0 0 10px'
  },
  uploadAction: {
    padding: 0,
    minWidth: 100
  },
  Input: {
    width: 450,
    maxWidth: '100%'
  }
}
